import { Button, Modal, Row } from "antd";
import PageLayout from "../../components/layout/PageLayout/PageLayout";
import TableThemes from "../../components/tables/TableThemes/TableThemes";
import FormTheme, { transformThemeToFormValues } from "../../components/forms/FormTheme";
import { useLazyFetchPaginatedThemesQuery } from "../../features/api/apiSlice";
import { useCrudTheme } from "../../features/api/crud/hooks/useCrudTheme";
import { useModal } from "../PageUsers/useModal";
import { modalProps } from "../../features/modals/modalProps";
import styles from "./PageThemes.module.scss";

const PageThemes: React.FC = () => {
  const [fetchThemes, { data, isFetching }] = useLazyFetchPaginatedThemesQuery();

  const { isModalOpen, modalItemId, onShowModal, onHideModal, onModifyShowModal } = useModal();

  const { createTheme, isCreating, updateTheme, isUpdating, onDelete, isDeleting } =
    useCrudTheme(modalItemId, () => fetchThemes(), onHideModal);

  const formMode = modalItemId ? "update" : "create";
  const modalTheme = data?.results?.find((t) => t.id === modalItemId);

  return (
    <PageLayout pageContainerClassName={styles.root}>
      <div className={styles.top}>
        <h1>Les thÃ¨mes</h1>
        <Button type="primary" onClick={onShowModal}>
          CrÃ©er un thÃ¨me
        </Button>
      </div>
      <Row>
        <TableThemes
          data={data}
          fetchData={fetchThemes}
          isLoading={isFetching || isDeleting}
          onModify={onModifyShowModal}
          onDelete={onDelete}
        />
      </Row>
      <Modal
        {...modalProps}
        title={formMode === "create" ? "CrÃ©er un thÃ¨me" : "Modifier un thÃ¨me"}
        open={isModalOpen}
        onCancel={onHideModal}
        footer={
          <>
            <Button onClick={onHideModal} disabled={isCreating || isUpdating}>
              Annuler
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              form="form-theme"
              loading={isCreating || isUpdating}
            >
              {formMode === "create" ? "Ajouter" : "Mettre Ã  jour"}
            </Button>
          </>
        }
      >
        <br />
        <FormTheme
          key={modalTheme?.id ?? "new"}
          onSubmit={formMode === "create" ? createTheme : updateTheme}
          defaultValues={transformThemeToFormValues(modalTheme)}
        />
      </Modal>
    </PageLayout>
  );
};

export default PageThemes;
